var portfolioCreate = {
	confirmBtn: "Ok",
	cancelBtn: "Cancelar",
	title: "Crear un nuevo portafolio",
	nameInputLabel: "Nombre del Portafolio",
	nameInputPlaceholder: "Por favor ingrese un nombre",
	nameInputTip: "Máximo 100 caracteres – Caracteres válidos: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ",
	currencyInputLabel: "Moneda base del portafolio",
	currencyInputPlaceholder: "Seleccione una moneda",
	limitExceededMessage: "Límite del portafolio superado.",
	currencies: {
		euro: "Euro",
		usd: "Dólares Estadounidenses",
		chf: "Francos Suizos",
		gbp: "Libra Británica",
		jpy: "Yen Japonés",
		cad: "Dolar Canadiense"
	},
	validationErrors: {
		name: {
			invalidInput: "El nombre no es válido. Máximo 100 caracteres – Caracteres válidos: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ"
		}
	}
};
var es = {
	portfolioCreate: portfolioCreate
};

export { es as default, portfolioCreate };
